import { Storage } from '@/util/storage';
import config from '@/config';

class TokenManager {
    private tokenKey = 'token';

    get(): Record<string, string> | undefined {
        const token = Storage.get(this.tokenKey);
        if (token && token.expire > Date.now()) {
            return {[config.scope + '-token']: token.token} ;
        }
    }

    del() {
        Storage.del(this.tokenKey);
    }

    set(token: { value: string; expire: number }) {
        Storage.set(this.tokenKey, token);
    }
}

export const tokenManager = new TokenManager();
